import {jsx as _jsx} from "react/jsx-runtime";import PlainButton from './PlainButton/PlainButton'






const SnackbarMessageAction = (props) => {
  const {action} = props
  if (!action) return null
  const {label, callback} = action
  return (
    _jsx(PlainButton, {
      className: "ml-2 whitespace-nowrap rounded-sm bg-[#ffffff17] p-2 font-semibold text-rose-500 text-sm leading-[normal] transition-[background] duration-100 ease-out hover:bg-[#ffffff26] focus:bg-[#ffffff26] active:bg-[#ffffff26]"              ,
      onClick: () => {
        // claude added this & i'm not sure why, we want it to propagate up to dismiss
        // e.stopPropagation()
        callback()
      },
 children: 
      label
    })
  )
}

export default SnackbarMessageAction
